module.exports = __webpack_public_path__ + "img/DeleteIcon.7acb4a55.svg";